// extracted by mini-css-extract-plugin
export default {"SignUp":"SignUp_SignUp__GUOc8","Form":"SignUp_Form__UWl8j","SocialAuth":"SignUp_SocialAuth__OVT9l","GoogleAuth":"SignUp_GoogleAuth__hLzM6","error":"SignUp_error__RVQvj"};